import { useTranslation } from "react-i18next";
import AuthoringPage from "../AuthoringPage";
import LabelListForm from "./LabelListForm";

export default function NewLabelListPage() {
  const { t } = useTranslation();
  return (
    <AuthoringPage title={t("authoring.labelList.newTitle")} intro={t("authoring.labelList.intro")}>
      {(projectId) => <LabelListForm projectId={projectId} base={null} />}
    </AuthoringPage>
  );
}
